import { wrappedR2A as react2angular } from '../../other/wrapped-react2angular.js';
import { VerificationCodeModal } from '@hotjar/webapp/features/Activation/VerificationCodeModal';

angular
    .module('hjApp')
    .component(
        'reactVerificationCodeModal',
        react2angular(VerificationCodeModal, [
            'email',
            'error',
            'isOpen',
            'onCancel',
            'onInput',
            'onSubmit',
            'onEmailLinkClick'
        ])
    );
